/** Fecha local YYYY-MM-DD (evita desfase UTC cerca de medianoche). */
export const todayIso = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const parseIso = (iso) => {
  const [y, m, d] = (iso || "").split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 12, 0, 0, 0);
};

export const toIso = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

/** Une history reciente + días del plan actual (hasta `pastLimit` días pasados). */
export const mergePlanDays = (plan, pastLimit = 30) => {
  if (!plan) return [];
  const hist = (plan.history || []).slice().sort((a, b) => a.date.localeCompare(b.date));
  const past = hist.filter((d) => d.date < plan.start_date).slice(-pastLimit);
  const map = new Map();
  [...past, ...(plan.days || [])].forEach((d) => map.set(d.date, d));
  return [...map.values()].sort((a, b) => a.date.localeCompare(b.date));
};
